export const jobStatusConfig = {
  draft: {
    id: 'draft',
    color: '#FFBE41',
    label: 'Draft',
    definition: 'Job not published yet',
  },
  published: {
    id: 'published',
    label: 'Open',
    color: '#73D017',
    definition: 'Job published and live',
  },
  closed: {
    id: 'closed',
    label: 'Closed',
    color: '#FF4141',
    definition: 'Job closed',
  },
  pending_approval: {
    id: 'pending_approval',
    label: 'Pending approval',
    color: '#D941FF',
    definition: 'Job pending approval to be published',
  },
  rejected: {
    id: 'rejected',
    label: 'Not approved',
    color: '#FF4141',
    definition:
      'Job not approved for publishing, can be resubmitted if allowed',
  },
  scheduled: {
    id: 'scheduled',
    label: 'Scheduled',
    color: '#3DD0FF',
    definition:
      'Job approved for publishing and scheduled to publish at a later date',
  },
  archived: {
    id: 'archived',
    label: 'Archived',
    color: '#585858',
    definition: '',
  },
};
